module.exports = __webpack_public_path__ + "static/media/partner-agents-banner.37b7bb3f.webp";